import maxBy from 'lodash/maxBy';

export const isActiveInquiry = (inquiry: Pick<BizlyAPI.Inquiry, 'isStale'>) => !(inquiry.isStale ?? false);

export const getCurrentInquiryFromList = (inquiries: BizlyAPI.Inquiry[]) =>
    maxBy(inquiries.filter(isActiveInquiry), 'id') ?? null;
